import Authenticated from 'components/Authenticated';
import PrivateLayout from 'content/layouts/Private';
import { RouteObject } from 'react-router-dom';
import dashboardRouter from './Dashboard';
import usersRouter from './Users/usersRouter';
import customersRouter from './Customers';
import locationsRouter from './Locations';
import pensRouter from './Pens';
import sitesRouter from './Sites';
import topboxesRouter from './TopBoxes/topboxesRouter';
import statisticsRouter from './Statistics';
import holeDetectionRouter from './Holes';
import maskBreakageRouter from './MaskBreakage';
import DepartmentsRouter from './Departments';
import AccessDenied from 'content/pages/Private/AccessDenied';

const privateRouter: RouteObject = {
  element: (
    <Authenticated>
      <PrivateLayout />
    </Authenticated>
  ),
  children: [
    ...dashboardRouter,
    ...usersRouter,
    ...locationsRouter,
    ...pensRouter,
    ...customersRouter,
    ...sitesRouter,
    ...topboxesRouter,
    ...statisticsRouter,
    ...holeDetectionRouter,
    ...maskBreakageRouter,
    ...DepartmentsRouter,
    {
      path: '*',
      element: <AccessDenied />,
    },
  ],
};

export default privateRouter;
